module.exports = __webpack_public_path__ + "img/fast_v1.4d91f8d.png";